export default {
  title: 'Premi',
  guest: {
    eyebrow: 'Premi',
    headline: 'Ogni ordine ti fa guadagnare <highlight>premi</highlight>',
    subheading_one: 'Guadagna {{count}} punto ogni {{amount}} speso.',
    subheading_other: 'Guadagna {{count}} punti ogni {{amount}} speso.',
    cta: 'Registrati e inizia a guadagnare',
    already_member: 'Sei già membro?',
    sign_in: 'Accedi',
    redeemable_heading: 'I tuoi punti = cibo gratis',
    redeemable_eyebrow: '🎁 Premi che sbloccherai',
  },
  member: {
    balance_label: 'Il tuo saldo',
    balance_suffix: 'punti · del valore di <highlight>{{amount}}</highlight>',
    next_reward: 'Prossimo premio a <highlight>{{points}} pt</highlight>',
    redeem_hint: '✓ Puoi riscattare fino a {{points}} pt ({{amount}}) sul tuo prossimo ordine',
    expiration_zero: '⏳ {{points}} pt scadono oggi',
    expiration_one: '⏳ {{points}} pt scadono in 1 giorno',
    expiration_other: '⏳ {{points}} pt scadono in {{count}} giorni',
    pts_lifetime: 'Pt totali',
    saved_lifetime: 'Risparmi totali',
    cta: 'Ordina ora',
    redeemable_heading: 'Cosa puoi riscattare',
    redeemable_eyebrow: 'Hai {{points}} pt ({{amount}})',
    redeemable_description:
      'Fino a {{maxPoints}} pt ({{maxAmount}}) per ordine. Gli articoli sotto {{maxAmount}} sono completamente gratuiti.',
  },
  items: {
    free: 'GRATIS',
    save: 'Risparmia {{amount}}',
  },
  history: {
    eyebrow: 'Cronologia',
    title: 'Attività recente',
    load_more: 'Carica altro',
    sources: {
      welcome_bonus: 'Bonus di benvenuto',
      google_review_reward: 'Premio per recensione Google',
      reward_loyalty_program_conversion: 'Conversione programma fedeltà',
      cashback: 'Cashback guadagnato',
      refund: 'Ordine rimborsato',
      cashback_usage: 'Punti riscattati',
      cashback_usage_refund: 'Riscatto rimborsato',
      expired_points_void: 'Punti scaduti',
      mobile_app_signup_bonus: 'Bonus iscrizione app mobile',
    },
    detail_with_order: 'Ordine #{{number}} · {{amount}}',
  },
  how_it_works: {
    eyebrow_guest: 'Semplice e Automatico',
    eyebrow_member: 'Promemoria veloce',
    title: 'Come funziona',
    steps: {
      sign_up: {
        emoji: '📲',
        title: 'Registrati gratis',
        desc: 'Crea un account in 30 secondi.',
      },
      order: {
        emoji: '🍔',
        title: 'Ordina e guadagna',
        desc_one: '1 pt per {{amount}} — tracciato in automatico.',
        desc_other: '{{count}} pt per {{amount}} — tracciato in automatico.',
      },
      build: {
        emoji: '⭐',
        title: 'Accumula punti',
        desc: 'Riscatta da {{minPoints}} pt. Validi {{lifetime}} giorni.',
      },
      save: {
        emoji: '🎁',
        title: 'Risparmia al pagamento',
        desc: 'Fino a {{maxAmount}} di sconto — applicato istantaneamente.',
      },
      repeat: {
        emoji: '🔄',
        title: 'Ripeti e risparmia',
        desc: 'Ogni ordine aumenta il tuo saldo.',
      },
    },
  },
  faq: {
    eyebrow: 'Domande?',
    title: 'Domande frequenti',
    items: {
      earn: {
        q: 'Come guadagno i punti?',
        a_one:
          'Guadagni 1 punto per ogni {{amount}} speso. I punti vengono aggiunti automaticamente al tuo account dopo ogni ordine — senza bisogno di scansioni o codici.',
        a_other:
          'Guadagni {{count}} punti per ogni {{amount}} speso. I punti vengono aggiunti automaticamente al tuo account dopo ogni ordine — senza bisogno di scansioni o codici.',
      },
      redeem: {
        q: 'Quando posso iniziare a riscattare?',
        a: "Puoi iniziare a riscattare una volta raggiunti {{minPoints}} punti. Usali al pagamento per ridurre il totale dell'ordine.",
      },
      max: {
        q: 'Quanto posso risparmiare per ordine?',
        a: 'Puoi riscattare fino a {{maxPoints}} punti ({{maxAmount}}) per ordine. È lo sconto massimo applicabile in un singolo pagamento.',
      },
      validity: {
        q: 'Per quanto tempo sono validi i punti?',
        a: 'I punti sono validi per {{lifetime}} giorni da quando vengono guadagnati. Usali prima che scadano!',
      },
    },
  },
};
